"use strict";
/**
 * @module indicative-rules
 */
Object.defineProperty(exports, "__esModule", { value: true });
const indicative_utils_1 = require("indicative-utils");
/**
 * Converts the field value to upper case. Also, this sanitization rule
 * is locale aware.
 *
 * ```ts
 * import { sanitizations } from 'indicative/sanitizer'
 *
 * const sanitizationRules = {
 *   hexCode: 'upper_case'
 * }
 *
 * // or
 * const sanitizationRules = {
 *   hexCode: [
 *     sanitizations.upperCase()
 *   ]
 * }
 * ```
 *
 * You may also specify a locale.
 *
 * ```js
 * const sanitizationRules = {
 *   label: 'upper_case:fr-CA'
 * }
 *
 * // or
 * const sanitizationRules = {
 *   label: [
 *     sanitizations.upperCase(['fr-CA'])
 *   ]
 * }
 */
const upperCase = {
    sanitize(data, field, args = []) {
        let fieldValue = indicative_utils_1.getValue(data, field);
        if (typeof (fieldValue) !== 'string') {
            return;
        }
        indicative_utils_1.patchValue(data, field, fieldValue.toLocaleUpperCase(args[0]));
    },
};
exports.default = upperCase;
